import React from 'react';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { withTranslation } from 'react-i18next';
import { getActiveStatus } from '../../utils/enrolleeStatus';

const capitalize = (str) => (str ? str.charAt(0).toUpperCase() + str.slice(1) : '');
class EnrolleeFilter extends React.Component {
  constructor(props) {
    super(props)
    this._isMounted = false;
    this.state = {
      searchTerm: '',
      isExporting: false
    }
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  safeSetState = (update) => {
    if (this._isMounted) this.setState(update);
  };

  handleSearchInput = (event) => {
    this.setState({searchTerm: event.target.value});
    this.props?.searchEnrollees(event.target.value);
  }

  sanitizeCSVField = (value) => {
    const str = value == null ? '' : String(value);
    const hasFormulaPrefix = /^[=+\-@\t\r]/.test(str);
    const needsQuoting = hasFormulaPrefix || /[",\n\r]/.test(str);
    const escaped = str.replace(/"/g, '""');
    return needsQuoting ? `"${escaped}"` : escaped;
  };

  convertToCSV = (columns, rows) => {
    const headerLine = columns.map((col) => this.sanitizeCSVField(col.label)).join(',');
    const dataLines = rows.map((row) =>
      columns
        .map((col) => {
          const rawValue = row[col.key];
          const formattedValue = col.format ? col.format(rawValue, row) : rawValue;
          return this.sanitizeCSVField(formattedValue);
        })
        .join(',')
    );
    return [headerLine, ...dataLines].join('\r\n');
  };

  downloadCSV = () => {
    const columns = [
      { key: 'id', label: 'Serial Number' },
      { key: 'first_name', label: 'First Name' },
      { key: 'last_name', label: 'Last Name' },
      { key: 'email_address', label: 'Email Address' },
      { key: 'phone_number', label: 'Phone' },
      {
        key: 'active_status_id',
        label: 'Status',
        format: (value) => capitalize(getActiveStatus(value))
      },
      { key: 'product_name', label: 'Plan' },
      {
        key: 'has_profile',
        label: 'Profile',
        format: (value) => (value ? 'Complete' : 'Incomplete')
      },
      { key: 'hmo_id', label: 'HMO_ID' }
    ];

    const { t, onExportError } = this.props;
    this.setState({ isExporting: true });
    onExportError?.(null);

    this.props.fetchAllEnrollees()
      .then((allData) => {
        const csvContent = '\uFEFF' + this.convertToCSV(columns, allData);
        const csvData = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
        const csvURL = URL.createObjectURL(csvData);
        const link = document.createElement('a');
        link.href = csvURL;
        link.download = `employees.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(csvURL);
      })
      .catch((err) => {
        console.error('Enrollee CSV export failed:', err);
        onExportError?.(t("employees.exportError", 'Export failed. Please try again.'));
      })
      .finally(() => {
        this.safeSetState({ isExporting: false });
      });
  };

  render() {
    const {searchTerm} = this.state;
    const { t } = this.props;

    return (
      <div className='table-paginator' style={{justifyContent: "space-between", gap: '15px'}}>
        <label htmlFor="active_status_filter" style={{margin: "0 0.6em", display: 'flex'}}>
          <input 
            type='text' 
            className="employee-search-field"
            placeholder={t("employees.filterSearchFieldInputPlaceholder")} 
            value={searchTerm} 
            onChange={this.handleSearchInput} 
          />
        </label>
        <label htmlFor="active_status_filter" style={{margin: "0 0.6em", display: 'flex'}}>
          <select id="active_status_filter" 
            value={this.props.status} 
            onChange={this.props.selectStatus} 
            style={{height: "30px", border: "1px solid #dedede", outline: "none", padding: '5px', fontSize: '12px'}}>
            <option value={''}>{t("employees.filterSelectFieldDefaultOption")}</option>
            <option value={1}>{t("employees.filterSelectFieldActiveOption")}</option>
            <option value={4}>{t("employees.filterSelectFieldSuspendedOption")}</option>
            <option value={6}>{t("employees.filterSelectFieldDeactivatedOption")}</option>
          </select>
        </label>
        <button onClick={this.downloadCSV} disabled={this.state.isExporting} className="employee-list-btn" style={{cursor: this.state.isExporting ? 'not-allowed' : 'pointer', background: 'white', border: '1px solid rgb(222, 222, 222)', color: this.state.isExporting ? 'rgba(0, 0, 0, 0.5)' : undefined}}>{this.state.isExporting ? t("employees.exportingText", "Exporting...") : t("employees.exportButtonText")} {!this.state.isExporting && <FileUploadOutlinedIcon/>}</button>
        <button onClick={this.props.addEmployees} className="employee-list-btn add-employee-btn" style={{cursor: 'pointer', background: ' #1c4f6f'}}>{t("employees.addEmployeeButtonText")}</button>
    </div>
    )
  }
}

export default withTranslation()(EnrolleeFilter);